import React from "react";
import { useI18n } from "../../i18n/I18nProvider";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "../ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher({ tone = "light" }) {
  const { locale, setLocale, locales } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-bold uppercase tracking-[0.18em] border transition-colors ${
          tone === "dark"
            ? "border-white/15 bg-white/5 text-white hover:bg-white/10"
            : "border-zinc-200 bg-white/70 text-zinc-700 hover:border-zinc-900 hover:text-oj-ink"
        }`}
        aria-label="Change language"
      >
        <Globe className="size-3.5" />
        {locale.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-switcher-menu" className="min-w-[160px]">
        {locales.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLocale(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex flex-col">
              <span className="text-sm font-semibold">{l.name}</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{l.label}</span>
            </span>
            {locale === l.code ? <Check className="size-4 text-oj-kiosk" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
